import {
  Button,
  Box,
  Typography,
  TableCell,
  TableRow,
  TableHead,
  Table,
  Paper,
  TableContainer,
  TableBody,
  Tooltip,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import NavigationHeader from "../../../components/NavigationHeader";
import { Container } from "@mui/material";
import { Add as AddIcon, Edit as EditIcon } from "@mui/icons-material";
import { MarketLoadType } from "./types";
import { marketLoadApi } from "./apiService";
import MarketLoadActionModal from "./MarketLoadActionModal";
import { Loading } from "../../../components/Loading";
import { tableHeaderStyles } from "../../../utils/styles";
import { tableCellStyles } from "../../../utils/styles";

const MarketLoad = () => {
  const [marketLoad, setMarketLoad] = useState<MarketLoadType[] | []>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [selectedMarketLoad, setSelectedMarketLoad] =
    useState<MarketLoadType | null>(null);
  const fetchMarketLoad = async () => {
    setIsLoading(true);
    const marketLoad = await marketLoadApi.getMarketLoad();
    setMarketLoad(marketLoad);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchMarketLoad();
  }, []);

  const handleEditMarketLoad = (marketLoad: MarketLoadType) => {
    setSelectedMarketLoad(marketLoad);
    setOpen(true);
  };

  const handleAddMarketLoad = () => {
    setSelectedMarketLoad(null);
    setOpen(true);
  };

  if (isLoading) {
    return <Loading message="Loading market load..." fullScreen={true} />;
  }

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      <NavigationHeader
        breadcrumbs={[
          { label: "Master Data", path: "/master-data" },
          { label: "Market Load/Outsourced" },
        ]}
        title="Market Load / Outsourced"
        button={{
          label: "Add Market Load",
          onClick: handleAddMarketLoad,
          icon: <AddIcon />,
        }}
      />
      {marketLoad?.length === 0 ? (
        <Typography variant="body1" sx={{ textAlign: "center", mt: 4 }}>
          No Market Load Information found
        </Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table size="small" aria-label="market load table">
            <TableHead>
              <TableRow>
                <TableCell {...tableHeaderStyles}>Vehicle Number</TableCell>
                <TableCell {...tableHeaderStyles}>Vehicle Company</TableCell>
                <TableCell {...tableHeaderStyles}>Owner Name</TableCell>
                <TableCell {...tableHeaderStyles}>Owner Contact</TableCell>
                <TableCell {...tableHeaderStyles}>Company Name</TableCell>
                <TableCell {...tableHeaderStyles}>
                  Primary Contact Name
                </TableCell>
                <TableCell {...tableHeaderStyles}>
                  Primary Contact Number
                </TableCell>
                <TableCell {...tableHeaderStyles}>GST Number</TableCell>
                <TableCell {...tableHeaderStyles} align="center">
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {marketLoad?.map((marketLoad) => (
                <TableRow
                  key={marketLoad?.id}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    "&:hover": { backgroundColor: "action.hover" },
                  }}
                >
                  <TableCell {...tableCellStyles}>
                    {marketLoad?.vehicleNumber || "-"}
                  </TableCell>
                  <TableCell {...tableCellStyles}>
                    {marketLoad?.vehicleCompanyName || "-"}
                  </TableCell>
                  <TableCell {...tableCellStyles}>
                    {marketLoad?.ownerName || "-"}
                  </TableCell>
                  <TableCell {...tableCellStyles}>
                    {marketLoad?.ownerContactNumber || "-"}
                  </TableCell>
                  <TableCell {...tableCellStyles}>
                    {marketLoad?.companyName || "-"}
                  </TableCell>
                  <TableCell {...tableCellStyles}>
                    {marketLoad?.primaryContactName || "-"}
                  </TableCell>
                  <TableCell {...tableCellStyles}>
                    {marketLoad?.primaryContactNumber || "-"}
                  </TableCell>
                  <TableCell {...tableCellStyles}>
                    {marketLoad?.gstNumber || "-"}
                  </TableCell>
                  <TableCell {...tableCellStyles} align="center">
                    <Tooltip title="Edit">
                      <IconButton
                        size="small"
                        onClick={() => handleEditMarketLoad(marketLoad)}
                      >
                        <EditIcon
                          fontSize="small"
                          sx={{ fontSize: "0.9rem" }}
                        />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <MarketLoadActionModal
        open={open}
        onClose={() => setOpen(false)}
        marketLoad={selectedMarketLoad}
        isEdit={selectedMarketLoad !== null}
        onSuccess={fetchMarketLoad}
      />
    </Container>
  );
};

export default MarketLoad;
